<template>
  <ul
    :class="['toggle_item', { link_txt: device === 'pc' }]"
    v-toggle="{
      target: 'toggleRef',
      selector: 'li > div.toggle_tit',
      onlyOpen: true,
      mustClose: true,
      dataType: Boolean,
    }"
    @onChange="changeFaq"
    ref="toggleRef"
  >
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[0] }]">
        <div class="tit">여러 직무에 중복지원 할 수 있나요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[0] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[0] }]">
        중복지원은 불가능합니다. 단, 회사에서 지원자의 경력을 종합적으로
        검토하여 지원자에게 다른 직무가 적합하다고 판단되면 지원자에게 다른
        직무를 제안 드릴 수 있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[1] }]">
        <div class="tit">지원서 작성 시 유의사항은 무엇인가요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[1] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[1] }]">
        지원서 작성 시 필수 입력 사항을 빠짐없이 작성해 주시기 바랍니다. 또한
        지원서를 허위로 작성하거나 고의로 일부 내용을 작성하지 않는 경우 서류
        전형에 불이익이 있고, 최종 합격 후 해당 사실이 발견되면 입사가 취소될 수
        있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[2] }]">
        <div class="tit">
          지원서에 잘못 작성한 내용이 있습니다. 면접전형에서 불이익이 있나요?
        </div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[2] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[2] }]">
        잘못 작성한 내용은 서류 접수기간 중 얼마든지 수정할 수 있습니다. 단,
        서류 접수기간 이후 지원서 내용이 사실과 다른 경우 불이익이 있으며 그
        책임은 지원자에게 있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[3] }]">
        <div class="tit">합격자 통보는 어떤 방식으로 진행되나요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[3] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[3] }]">
        서류전형 및 면접전형 결과는 합격자에 한해 문자메시지로 안내드립니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[4] }]">
        <div class="tit">
          예전에 불합격한 경험이 있습니다. 다시 지원할 수 있나요?
        </div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[4] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[4] }]">
        가능합니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[5] }]">
        <div class="tit">신입 및 경력사원 공채 시기가 따로 정해져 있나요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[5] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[5] }]">
        한국오션플랫폼은 필요에 따라 수시로 채용을 진행합니다. 채용공고는
        한국오션플랫폼 홈페이지와 취업 관련 사이트를 확인해 주시기 바랍니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[6] }]">
        <div class="tit">
          모집 전공과 다른 분야를 전공해도 지원할 수 있나요?
        </div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[6] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[6] }]">
        원칙적으로는 채용분야별로 모집 전공을 제한합니다. 단, 모집 전공과 관련이
        있거나 비슷한 전공의 범위를 폭넓게 인정하며, 해당 범위 안에서 지원할 수
        있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[7] }]">
        <div class="tit">나이 제한이나 성별 제한이 있습니까?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[7] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[7] }]">
        나이와 성별에 상관없이 누구나 지원할 수 있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[8] }]">
        <div class="tit">
          외국어 점수나 자격증은 평가에 어느 정도 영향을 미치나요?
        </div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[8] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[8] }]">
        외국어 점수나 자격증은 평가에 절대적 영향을 미치지는 않습니다. 단,
        지원하신 부문이 외국어 능력이나 자격증을 필요로 하는 경우 가점을 받을 수
        있습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[9] }]">
        <div class="tit">채용검진 과정에서도 불합격하는 경우가 있나요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[9] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[9] }]">
        채용검진은 채용의 중요한 전형 과정 중 하나로, 회사가 정하는 기준을
        충족하지 못할 때는 불합격할 수 있습니다. 단, 신체장애를 이유로 채용
        과정에서 차별을 하지 않습니다.
      </div>
    </li>
    <li>
      <div :class="['toggle_tit', { active: faqToggleActs[10] }]">
        <div class="tit">면접은 어떤 식으로 진행되나요?</div>
        <button
          type="button"
          :class="['bnt_plus', { active: faqToggleActs[10] }]"
        >
          내용보기
        </button>
      </div>

      <div :class="['toggle_cont', { active: faqToggleActs[10] }]">
        대졸 신입사원의 경우 서류전형, 면접 순으로 진행되며, 면접은 1차와 2차로
        나누어 진행됩니다. 면접에는 실무 관리자와 임원급 면접관이 참석할 수
        있으며, 집단 비교면접 형태로 진행됩니다. 경우에 따라서 면접의 유형이
        달라질 수 있으며, 지원 직무에 따라 특별 면접이 추가될 수 있습니다.
      </div>
    </li>
  </ul>
</template>

<script>
import page from '@/mixins/page';
/**
 * @module pages/recruit/p_recruit028
 * @desc 인재채용 > 채용안내 > _FaqList
 * @vue-data {Array} faqToggleActs=Array - FAQ 아코디언 상태 값
 */
export default {
  mixins: [page],
  data() {
    return {
      faqToggleActs: Array.from({ length: 11 }).fill(false)
    };
  },
  methods: {
    /**
     * 토글 조작 시 값 업데이트
     * @param {Object} params 토글 상태 값
     * @param {Array} params.acts 활성화 된 토글 배열 값
     */
    changeFaq({ acts }) {
      this.faqToggleActs = acts;
    }
  }
};
</script>

<style lang="scss" scoped></style>
